module.exports = __webpack_public_path__ + "static/viljapelto2-490x368-2256.ad76bcca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/viljapelto2-490x368-2256.jpg
// module id = 857
// module chunks = 95015380831008